module.exports = __webpack_public_path__ + "static/media/icon_bill.607b07d6.png";